export const QA_NAME_LISTING_APPLICANTS_NEW = 'listingApplicantsNew'
